import { all } from 'redux-saga/effects'

import { invitesSaga } from './invites/sagas'
import { jobRecommendationsSaga } from './job-recommendations/sagas'

export function* jobInviteSaga() {
  yield all([invitesSaga(), jobRecommendationsSaga()])
}
